import { CdkMenuModule } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProfileSite } from '@ffd/api-client';
import { AvatarsComponent, Person, TooltipModule } from '@libs/ui-lib';
import { ffdNotesRoutePrefix, routes } from '@libs/utils';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PushTagOnClickDirective, TagEvent } from '@libs/shared-services';

@Component({
  selector: 'lib-ffd-notes-header-profile',
  templateUrl: './ffd-notes-header-profile.component.html',
  styleUrls: ['./ffd-notes-header-profile.component.scss'],
  standalone: true,
  imports: [CommonModule, AvatarsComponent, CdkMenuModule, TranslateModule, RouterModule, TooltipModule, PushTagOnClickDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNotesHeaderProfileComponent {
  public user = input.required<Person>();
  public selectedSite = input.required<ProfileSite | null>();
  public sitesCount = input.required<number | null>();

  protected routes = routes;
  protected TagEvent = TagEvent;
  protected myAccountRoute = [...ffdNotesRoutePrefix(), routes.myAccount];
}
